import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
// import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "@fontsource/poppins";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import App from './App';
import {Provider} from 'react-redux'
import store from './redux/store'
import reportWebVitals from './reportWebVitals';
import Login from './routes/Onboarding/UserLogin'
import ForgotPassword from "./routes/Onboarding/ForgotPassword"
import Home from './routes/Home'
import WorkOrders from "./routes/WorkOrders/WorkOrders";
import Settings from "./routes/Settings/Settings"
import UnderwritingDetails from "./routes/WorkOrders/UnderwritingDetails"
import AttomSearch from "./routes/Attom/Search";


import {BrowserRouter, Route, Routes} from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App/>}/>
        <Route path="/login" element={<Login/>}/>
	      <Route path="/forgot-password" element={<ForgotPassword/>}/>
        <Route path="/home" element={<Home/>}>
					<Route path="work-orders" element={<WorkOrders/>}/>
					<Route path="underwriting-details" element={<UnderwritingDetails />}/>
	        <Route path="attom-search" element={<AttomSearch/>}/>
					<Route path="settings" element={<Settings/>}/>
          {/*<Route path="rooms" element={<Rooms />} >
                <Route path=":roomId" element={<Room />} />
              </Route>*/}
        </Route>
        <Route
          path="*"
          element={
            <main style={{padding: "1rem"}}>
              <h1>Error 404 - page not found</h1>
            </main>
          }
        />
      </Routes>
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
